import { render } from "./RegisterIva.vue?vue&type=template&id=e02c4db4"
import script from "./RegisterIva.vue?vue&type=script&lang=js"
export * from "./RegisterIva.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__